import React, { Component } from 'react';
import { select } from 'd3-selection';
import { forceSimulation, forceCollide, forceManyBody, forceCenter, forceLink } from 'd3-force';
import { zoom } from 'd3-zoom';
import { event, mouse } from 'd3-selection';
import { drag } from 'd3-drag';
import { json } from 'd3-fetch';
import { rgb } from 'd3-color';
import includes from "lodash-es/includes";

import { 
    rotation,
    unitaryVector,
    unitaryNormalVector,
    rotatePoint,
    contains,
    toString,
    colors
} from "components/graph/util/neo4jd3";

class Neo4jD3 extends Component {

    constructor(props) {
        super(props);

        this.options = {
            arrowSize: 4,
            colors: colors(),
            highlight: undefined,
            iconMap: undefined,
            icons: undefined,
            imageMap: {},
            images: undefined,
            infoPanel: true,
            minCollision: props._options.minCollision ? props._options.minCollision : props._options.nodeRadius * 2,
            neo4jData: undefined,
            neo4jDataUrl: undefined,
            nodeOutlineFillColor: undefined,
            nodeRadius: 25,
            relationshipColor: '#a5abb6',
            zoomFit: false,
            showIcons: props._options.icons ? true : false,
            classes2colors: {},
            relationshipText: {},
            ...props._options, // 초기화
        };

        this.neo4jD3Ref = React.createRef();

        //this.classes2colors = {};
        this.justLoaded = false
        this.numClasses = 0;

        this.container = null;
        this.info = null;

        this.simulation = null;

        this.svg = null;
        this.svgNodes = null;
        this.svgRelationships = null;
        this.svgScale = null;
        this.svgTranslate = null;

        this.node = null;
        this.nodes = null;

        this.relationship = null;
        this.relationshipText = null;
        this.relationshipOutline = null;
        this.relationshipOverlay = null;

        this.relationships = null;

    }

    getWidth(){
        return this.neo4jD3Ref.current.parentElement.offsetWidth -20;
    }
    getHeight(){
        return this.neo4jD3Ref.current.parentElement.offsetHeight -20;
    }

    // 리렌더링이 불필요한 케이스 정의 
    shouldComponentUpdate(nextProps, nextState){
        console.log(this.props._data);
        if (
            nextProps._data === this.props._data
        ) {
            console.log("Neo4jD3 >> shouldComponentUpdate : false");
            return false;
        }
        console.log("Neo4jD3 >> shouldComponentUpdate : true");
        return true;
    }

    componentDidMount() {
        console.log("Neo4jD3 >> componentDidMount");
        this.init();

        if(this.props._data && this.props._data.results){
            if(this.props._queryType === 'init') {
                this.loadNeo4jDataFromServer();
            } 
        }
    }

    componentDidUpdate(prevProps, prevState) {
        console.log("Neo4jD3 >> componentDidUpdate");

        if(this.props._data && this.props._data.results){
            if(this.props._queryType === 'add') {
                this.loadAddedNeo4jDataFromServer();
            } else if(this.props._queryType === 'init'){
                this.loadNeo4jDataFromServer();
            }
        }

    }

    init() {
        this.container = select(`#${this.props._selector}`);

        // 처음 화면을 초기화 한다.
        this.container.attr('class', 'neo4jd3').html('');

        // 노드 정보를 보여주는 초기화 화면 추가
        if (this.options.infoPanel) {
            this.info = this.appendInfoPanel(this.container);
        }
        
        // 그래프가 보여지는 초기화 화면 추가
        this.appendGraph(this.container);

        this.simulation = this.initSimulation();

        //데이터 로딩 (테스트 용도)
        if (this.options.neo4jData) {
            this.loadNeo4jData(this.options.neo4jData);
        } else if (this.options.neo4jDataUrl) {
            this.loadNeo4jDataFromUrl(this.options.neo4jDataUrl);
        }

    }

    appendInfoPanel(container) {
        return container.append('div')
                        .attr('class', 'neo4jd3-info');
    }

    appendGraph(container) {
        
        let width = this.getWidth()
        let height = this.getHeight();

        this.svg = container.append('svg')
                            // .attr('width', '100%')
                            // .attr('height', '100%')
                            .attr("preserveAspectRatio", "xMinYMin meet")
                            .attr("viewBox", `0 0 ${width} ${height}`)
                            .attr('class', 'neo4jd3-graph')
                            .call(zoom().on( 'zoom', () => {
                                let scale = event.transform.k,
                                translate = [event.transform.x, event.transform.y];
                
                                if (this.svgTranslate) {
                                    translate[0] += this.svgTranslate[0];
                                    translate[1] += this.svgTranslate[1];
                                }
                
                                if (this.svgScale) {
                                    scale *= this.svgScale;
                                }
                
                                this.svg.attr('transform', 'translate(' + translate[0] + ', ' + translate[1] + ') scale(' + scale + ')');
                            }))
                            .on('dblclick.zoom', null)
                            .append('g')
                            .attr('width', '100%')
                            .attr('height', '100%');

        this.svgRelationships = this.svg.append('g')
                                        .attr('class', 'relationships');
                                        
        this.svgNodes = this.svg.append('g')
                                .attr('class', 'nodes');
    }

    initSimulation() {
        let simulation = forceSimulation()
//                           .velocityDecay(0.8)
//                           .force('x', d3.force().strength(0.002))
//                           .force('y', d3.force().strength(0.002))
                        .force('collide', forceCollide().radius((d) => {
                            return this.options.minCollision;
                        }).iterations(2))
                        .force('charge', forceManyBody())
                        .force('link', forceLink().id((d) => {
                            return d.id;
                        }))
                        .force('center', forceCenter(this.svg.node().parentElement.parentElement.clientWidth / 2, this.svg.node().parentElement.parentElement.clientHeight / 2))
                        .on('tick', () => {
                            this.tick();
                        })
                        .on('end', () => {
                            if (this.options.zoomFit && !this.justLoaded) {
                                this.justLoaded = true;
                                this.zoomFit(2);
                            }
                        });

        return simulation;
    }

    tick() {
        this.tickNodes();
        this.tickRelationships();
    }

    tickNodes() {
        if (this.node) {
            this.node.attr('transform', (d) => {
                return 'translate(' + d.x + ', ' + d.y + ')';
            });
        }
    }

    tickRelationships() {
        if (this.relationship) {
            this.relationship.attr('transform', (d) => {
                const angle = rotation(d.source, d.target);
                return 'translate(' + d.source.x + ', ' + d.source.y + ') rotate(' + angle + ')';
            });

            this.tickRelationshipsTexts();
            this.tickRelationshipsOutlines();
            this.tickRelationshipsOverlays();
        }
    }

    tickRelationshipsTexts() {
        this.relationshipText.attr('transform', (d) => {
            const angle = (rotation(d.source, d.target) + 360) % 360,
                mirror = angle > 90 && angle < 270,
                center = { x: 0, y: 0 },
                n = unitaryNormalVector(d.source, d.target),
                nWeight = mirror ? 2 : -3,
                point = { x: (d.target.x - d.source.x) * 0.5 + n.x * nWeight, y: (d.target.y - d.source.y) * 0.5 + n.y * nWeight },
                rotatedPoint = rotatePoint(center, point, angle);

            return 'translate(' + rotatedPoint.x + ', ' + rotatedPoint.y + ') rotate(' + (mirror ? 180 : 0) + ')';
        });
    }

    tickRelationshipsOverlays() {
        this.relationshipOverlay.attr('d', (d) => {
            const center = { x: 0, y: 0 },
                angle = rotation(d.source, d.target),
                n1 = unitaryNormalVector(d.source, d.target),
                n = unitaryNormalVector(d.source, d.target, 50),
                rotatedPointA = rotatePoint(center, { x: 0 - n.x, y: 0 - n.y }, angle),
                rotatedPointB = rotatePoint(center, { x: d.target.x - d.source.x - n.x, y: d.target.y - d.source.y - n.y }, angle),
                rotatedPointC = rotatePoint(center, { x: d.target.x - d.source.x + n.x - n1.x, y: d.target.y - d.source.y + n.y - n1.y }, angle),
                rotatedPointD = rotatePoint(center, { x: 0 + n.x - n1.x, y: 0 + n.y - n1.y }, angle);

            return 'M ' + rotatedPointA.x + ' ' + rotatedPointA.y +
                   ' L ' + rotatedPointB.x + ' ' + rotatedPointB.y +
                   ' L ' + rotatedPointC.x + ' ' + rotatedPointC.y +
                   ' L ' + rotatedPointD.x + ' ' + rotatedPointD.y +
                   ' Z';
        });
    }

    tickRelationshipsOutlines = () => {
        let options = this.options;
        this.relationship.each(function(relationship){
            //var rel = select(this);`relationship-${d.id}`;
            const rel = select(this);
            const outline = rel.select('.outline'),
                text = rel.select('.text'),
                bbox = text.node().getBBox(),
                padding = 3;


            outline.attr('d', (d) => {
                const center = { x: 0, y: 0 },
                    angle = rotation(d.source, d.target),
                    textBoundingBox = text.node().getBBox(),
                    textPadding = 5,
                    u = unitaryVector(d.source, d.target),
                    textMargin = { x: (d.target.x - d.source.x - (textBoundingBox.width + textPadding) * u.x) * 0.5, y: (d.target.y - d.source.y - (textBoundingBox.width + textPadding) * u.y) * 0.5 },
                    n = unitaryNormalVector(d.source, d.target),
                    rotatedPointA1 = rotatePoint(center, { x: 0 + (options.nodeRadius + 1) * u.x - n.x, y: 0 + (options.nodeRadius + 1) * u.y - n.y }, angle),
                    rotatedPointB1 = rotatePoint(center, { x: textMargin.x - n.x, y: textMargin.y - n.y }, angle),
                    rotatedPointC1 = rotatePoint(center, { x: textMargin.x, y: textMargin.y }, angle),
                    rotatedPointD1 = rotatePoint(center, { x: 0 + (options.nodeRadius + 1) * u.x, y: 0 + (options.nodeRadius + 1) * u.y }, angle),
                    rotatedPointA2 = rotatePoint(center, { x: d.target.x - d.source.x - textMargin.x - n.x, y: d.target.y - d.source.y - textMargin.y - n.y }, angle),
                    rotatedPointB2 = rotatePoint(center, { x: d.target.x - d.source.x - (options.nodeRadius + 1) * u.x - n.x - u.x * options.arrowSize, y: d.target.y - d.source.y - (options.nodeRadius + 1) * u.y - n.y - u.y * options.arrowSize }, angle),
                    rotatedPointC2 = rotatePoint(center, { x: d.target.x - d.source.x - (options.nodeRadius + 1) * u.x - n.x + (n.x - u.x) * options.arrowSize, y: d.target.y - d.source.y - (options.nodeRadius + 1) * u.y - n.y + (n.y - u.y) * options.arrowSize }, angle),
                    rotatedPointD2 = rotatePoint(center, { x: d.target.x - d.source.x - (options.nodeRadius + 1) * u.x, y: d.target.y - d.source.y - (options.nodeRadius + 1) * u.y }, angle),
                    rotatedPointE2 = rotatePoint(center, { x: d.target.x - d.source.x - (options.nodeRadius + 1) * u.x + (- n.x - u.x) * options.arrowSize, y: d.target.y - d.source.y - (options.nodeRadius + 1) * u.y + (- n.y - u.y) * options.arrowSize }, angle),
                    rotatedPointF2 = rotatePoint(center, { x: d.target.x - d.source.x - (options.nodeRadius + 1) * u.x - u.x * options.arrowSize, y: d.target.y - d.source.y - (options.nodeRadius + 1) * u.y - u.y * options.arrowSize }, angle),
                    rotatedPointG2 = rotatePoint(center, { x: d.target.x - d.source.x - textMargin.x, y: d.target.y - d.source.y - textMargin.y }, angle);

                return 'M ' + rotatedPointA1.x + ' ' + rotatedPointA1.y +
                       ' L ' + rotatedPointB1.x + ' ' + rotatedPointB1.y +
                       ' L ' + rotatedPointC1.x + ' ' + rotatedPointC1.y +
                       ' L ' + rotatedPointD1.x + ' ' + rotatedPointD1.y +
                       ' Z M ' + rotatedPointA2.x + ' ' + rotatedPointA2.y +
                       ' L ' + rotatedPointB2.x + ' ' + rotatedPointB2.y +
                       ' L ' + rotatedPointC2.x + ' ' + rotatedPointC2.y +
                       ' L ' + rotatedPointD2.x + ' ' + rotatedPointD2.y +
                       ' L ' + rotatedPointE2.x + ' ' + rotatedPointE2.y +
                       ' L ' + rotatedPointF2.x + ' ' + rotatedPointF2.y +
                       ' L ' + rotatedPointG2.x + ' ' + rotatedPointG2.y +
                       ' Z';
            });
        });
    }

    zoomFit(transitionDuration) {
        const bounds = this.svg.node().getBBox(),
            parent = this.svg.node().parentElement.parentElement,
            fullWidth = parent.clientWidth,
            fullHeight = parent.clientHeight,
            width = bounds.width,
            height = bounds.height,
            midX = bounds.x + width / 2,
            midY = bounds.y + height / 2;

        if (width === 0 || height === 0) {
            return; // nothing to fit
        }

        this.svgScale = 0.85 / Math.max(width / fullWidth, height / fullHeight);
        this.svgTranslate = [fullWidth / 2 - this.svgScale * midX, fullHeight / 2 - this.svgScale * midY];

        this.svg.attr('transform', 'translate(' + this.svgTranslate[0] + ', ' + this.svgTranslate[1] + ') scale(' + this.svgScale + ')');
    }
    // 초기화 function 정의 end

    // 데이터 그래프화 start
    loadNeo4jData = () => {
        this.nodes = [];
        this.relationships = [];

        this.updateWithNeo4jData(this.options.neo4jData);
    }

    loadNeo4jDataFromUrl(neo4jDataUrl) {
        this.nodes = [];
        this.relationships = [];

        json(neo4jDataUrl, function(error, data) {
            if (error) {
                throw error;
            }
            this.updateWithNeo4jData(data);
        });
    }

    loadNeo4jDataFromServer = () => {
        this.nodes = [];
        this.relationships = [];
        this.updateWithNeo4jData(this.props._data);

    }

    loadAddedNeo4jDataFromServer() {
        this.updateWithAddedNeo4jData(this.props._data)
    }

    updateWithNeo4jData(neo4jData){
        const d3Data = this.neo4jDataToD3Data(neo4jData);
        this.updateWithD3Data(d3Data);
    }

    updateWithAddedNeo4jData(neo4jData){
        const d3Data = this.neo4jAddedDataToD3Data(neo4jData);
        this.updateWithD3Data(d3Data);
    }

    neo4jDataToD3Data = (data) => {
        const graph = {
            nodes: [],
            relationships: []
        };

        data.results.forEach(function(result) {
            result.data.forEach(function(data) {
                data.graph.nodes.forEach(function(node) {
                    if (!contains(graph.nodes, node.id)) {
                        graph.nodes.push(node);
                    }
                });

                data.graph.relationships.forEach(function(relationship) {
                    if (!contains(graph.relationships, relationship.id)) {
                        relationship.source = relationship.startNode;
                        relationship.target = relationship.endNode;
                        //relationship.ref = createRef();
                        graph.relationships.push(relationship);
                    }

                });


                data.graph.relationships.sort(function(a, b) {
                    if (a.source > b.source) {
                        return 1;
                    } else if (a.source < b.source) {
                        return -1;
                    } else {
                        if (a.target > b.target) {
                            return 1;
                        }

                        if (a.target < b.target) {
                            return -1;
                        } else {
                            return 0;
                        }
                    }
                });

                for (var i = 0; i < data.graph.relationships.length; i++) {
                    if (i !== 0 && data.graph.relationships[i].source === data.graph.relationships[i-1].source && data.graph.relationships[i].target === data.graph.relationships[i-1].target) {
                        data.graph.relationships[i].linknum = data.graph.relationships[i - 1].linknum + 1;
                    } else {
                        data.graph.relationships[i].linknum = 1;
                    }
                }
            });
        });

        return graph;
    }

    neo4jAddedDataToD3Data = (data) => {
        const graph = {
            nodes: [],
            relationships: []
        };

        let _searchNode = this.props._searchNode;
        let nodes = this.nodes;
        let relationships = this.relationships;
        this.props._data.results.forEach(function(result) {
            result.data.forEach(function(data) {
                data.graph.nodes.forEach(function(node) {
                    if (!contains(graph.nodes, node.id)) {

                        if(!contains(nodes, node.id)) {
                            node.x = _searchNode.x;
                            node.y = _searchNode.y;
                            graph.nodes.push(node);
                        }

                    }
                });

                data.graph.relationships.forEach(function(relationship) {
                    if (!contains(graph.relationships, relationship.id)) {
                        if(!contains(relationships, relationship.id)){
                            relationship.source = relationship.startNode;
                            relationship.target = relationship.endNode;
                            graph.relationships.push(relationship);
                        }
                    }
                });


                for (var i = 0; i < data.graph.relationships.length; i++) {
                    if (i !== 0 && data.graph.relationships[i].source === data.graph.relationships[i-1].source && data.graph.relationships[i].target === data.graph.relationships[i-1].target) {
                        data.graph.relationships[i].linknum = data.graph.relationships[i - 1].linknum + 1;
                    } else {
                        data.graph.relationships[i].linknum = 1;
                    }
                }
            });
        });

        return graph;
    }

    updateWithD3Data(d3Data) {
        this.updateNodesAndRelationships(d3Data.nodes, d3Data.relationships);
    }

    updateNodesAndRelationships(n, r) {
        this.updateRelationships(r);
        this.updateNodes(n);

        this.simulation.nodes(this.nodes);
        this.simulation.force('link').links(this.relationships);
    }

    updateRelationships = (r) =>{
        Array.prototype.push.apply(this.relationships, r);

        this.relationship = this.svgRelationships.selectAll('.relationship')
                                       .data(this.relationships, function(d) { return d.id; });

        var relationshipEnter = this.appendRelationshipToGraph();

        this.relationship = relationshipEnter.relationship.merge(this.relationship);

        this.relationshipOutline = this.svg.selectAll('.relationship .outline');
        this.relationshipOutline = relationshipEnter.outline.merge(this.relationshipOutline);

        this.relationshipOverlay = this.svg.selectAll('.relationship .overlay');
        this.relationshipOverlay = relationshipEnter.overlay.merge(this.relationshipOverlay);

        this.relationshipText = this.svg.selectAll('.relationship .text');
        this.relationshipText = relationshipEnter.text.merge(this.relationshipText);
    }

    updateNodes(n) {
        Array.prototype.push.apply(this.nodes, n);

        this.node = this.svgNodes.selectAll('.node')
                       .data(this.nodes, function(d) { return d.id; });
        let nodeEnter = this.appendNodeToGraph();
        this.node = nodeEnter.merge(this.node);
    }

    appendNodeToGraph() {
        let n = this.appendNode();

        this.appendRingToNode(n);
        this.appendOutlineToNode(n);

        if (this.options.icons) {
            this.appendTextToNode(n);
        }

        if (this.options.images) {
            this.appendImageToNode(n);
        }

        return n;
    }

    icon(d) {
        let code;
        if (this.options.iconMap && this.options.showIcons && this.options.icons) {
            // 미리 어떤 이미지를 사용할 지 이전에 정의된 이름으로 Font Awesome 아이콘에서 찾는다.
            if (this.options.icons[d.labels[0]] && this.options.iconMap[this.options.icons[d.labels[0]]]) {
                code = this.options.iconMap[this.options.icons[d.labels[0]]];
            // 따로 어떤 아이콘을 사용할 지 정의를 안했으면 라벨 값을 가지고 Font Awesome 아이콘에서 찾는다.
            } else if (this.options.iconMap[d.labels[0]]) {
                code = this.options.iconMap[d.labels[0]];
            } else if (this.options.icons[d.labels[0]]) {
                code = this.options.icons[d.labels[0]];
            }
        }
        return code;
    }

    image = (d) => {
        let i, imagesForLabel, img, imgLevel, label, labelPropertyValue, property, value;

        if (this.options.images) {
            imagesForLabel = this.options.imageMap[d.labels[0]];

            if (imagesForLabel) {
                imgLevel = 0;

                for (i = 0; i < imagesForLabel.length; i++) {
                    labelPropertyValue = imagesForLabel[i].split('|');

                    switch (labelPropertyValue.length) {
                        case 3:
                        value = labelPropertyValue[2];
                        /* falls through */
                        case 2:
                        property = labelPropertyValue[1];
                        /* falls through */
                        case 1:
                        label = labelPropertyValue[0];
                    }

                    if (d.labels[0] === label &&
                        (!property || d.properties[property] !== undefined) &&
                        (!value || d.properties[property] === value)) {
                        if (labelPropertyValue.length > imgLevel) {
                            img = this.options.images[imagesForLabel[i]];
                            imgLevel = labelPropertyValue.length;
                        }
                    }
                }
            }
        }

        return img;
    }

    appendNode() {
        return this.node.enter()
                   .append('g')
                   .attr('class', (d) => {
                       let highlight, i,
                           classes = 'node',
                           label = d.labels[0];

                        // 라벨을 위한 Font Awesome 아이콘이 존재하면 아이콘을 보여주지만 없으면 아래 이미지에서 라벨을 표현한다.
                        // Font Awesome 아이콘과 이미지가 모두 존재하면 이미지는 라벨을 위한 원의 아래에 작은 이미지로 보여진다.
                        if (this.icon(d)) {
                            classes += ' node-icon';
                        }
                        if (this.image(d)) {
                            classes += ' node-image';
                        }

                       if (this.options.highlight) {
                           for (i = 0; i < this.options.highlight.length; i++) {
                               highlight = this.options.highlight[i];

                                // if (d.labels[0] === highlight.class && d.properties[highlight.property] === highlight.value) {
                                if (d.labels[0] === highlight.class && includes(d.properties[highlight.property], highlight.value)) {
                                   classes += ' node-highlighted';
                                   break;
                               }
                           }
                       }

                       return classes;
                   })
                   .on('click', (d) => {
                       d.fx = d.fy = null;

                       if (typeof this.options.onNodeClick === 'function') {
                            this.options.onNodeClick(d);
                       }
                   })
                   .on('dblclick', (d) => {
                        this.stickNode(d); //  잘못된 값을 받아와서 일단 주석처리

                    // /this.stickNode(d) 값이 잘못되서 일단 임시 처리
                        // d.fx = d.x;
                        // d.fy = d.y;

                       if (typeof this.options.onNodeDoubleClick === 'function') {
                            this.options.onNodeDoubleClick(d);
                       }
                   })
                   .on('mouseenter', (d) => {
                       if (this.info) {
                           this.updateInfo(d);
                       }

                       if (typeof this.options.onNodeMouseEnter === 'function') {
                            this.options.onNodeMouseEnter(d);
                       }
                   })
                   .on('mouseleave', (d) => {
                       if (this.info) {
                           this.clearInfo(d);
                       }

                       if (typeof this.options.onNodeMouseLeave === 'function') {
                           this.options.onNodeMouseLeave(d);
                       }
                   })
                   .call(drag()
                           .on('start', this.dragStarted)
                           .on('drag', this.dragged)
                           .on('end', this.dragEnded));
    }

    appendRingToNode(node) {
        return node.append('circle')
                   .attr('class', 'ring')
                   .attr('r', this.options.nodeRadius * 1.16)
                   .append('title').text((d) => {
                       return toString(d);
                   });
    }

    appendOutlineToNode(node) {
        return node.append('circle')
                   .attr('class', 'outline')
                   .attr('r', this.options.nodeRadius)
                   .style('fill', (d) => {
                       return this.options.nodeOutlineFillColor ? this.options.nodeOutlineFillColor : this.class2color(d.labels[0]);
                   })
                   .style('stroke', (d) => {
                       return this.options.nodeOutlineFillColor ? this.class2darkenColor(this.options.nodeOutlineFillColor) : this.class2darkenColor(d.labels[0]);
                   })
                   .append('title').text((d) => {
                       return toString(d);
                   });
    }

    appendTextToNode(node) {
        return node.append('text')
                   .attr('class', (d) => {
                       return 'text' + (this.icon(d) ? ' icon' : '');
                   })
                   .attr('fill', '#ffffff')
                   .attr('font-size', (d) => {
                       return this.icon(d) ? (this.options.nodeRadius + 'px') : '10px';
                   })
                   .attr('pointer-events', 'none')
                   .attr('text-anchor', 'middle')
                   .attr('y', (d) => {
                       return this.icon(d) ? (parseInt(Math.round(this.options.nodeRadius * 0.32)) + 'px') : '4px';
                   })
                   .html((d) => {
                       let _icon = this.icon(d);
                       return _icon ? '&#x' + _icon : d.id;
                   });
    }

    appendImageToNode(node) {
        return node.append('image')
                   .attr('height', (d) => {
                       return this.icon(d) ? '24px': '30px';
                   })
                   .attr('x', (d) => {
                       return this.icon(d) ? '5px': '-15px';
                   })
                   .attr('xlink:href', (d) => {
                       return this.image(d);
                   })
                   .attr('y', (d) => {
                       return this.icon(d) ? '5px': '-16px';
                   })
                   .attr('width', (d) => {
                       return this.icon(d) ? '24px': '30px';
                   });
    }

    appendRelationshipToGraph = () =>{
        let relationship = this.appendRelationship(),
            text = this.appendTextToRelationship(relationship),
            outline = this.appendOutlineToRelationship(relationship),
            overlay = this.appendOverlayToRelationship(relationship);

        return {
            relationship: relationship,
            text: text,
            outline: outline,
            overlay: overlay
        };
    }

    appendRelationship = () =>{
        return this.relationship.enter()
                           .append('g')
                           .attr('class', 'relationship')
                           .on('dblclick', (d) => {
                               if (typeof this.options.onRelationshipDoubleClick === 'function') {
                                   this.options.onRelationshipDoubleClick(d);
                               }
                           })
                           .on('mouseenter', (d) => {
                               if (this.info) {
                                   this.updateInfo(d);
                               }
                           });
    }

    appendTextToRelationship = (r) => {
        return r.append('text')
                .attr('class', 'text')
                .attr('fill', '#000000')
                .attr('font-size', '8px')
                .attr('pointer-events', 'none')
                .attr('text-anchor', 'middle')
                .text((d) => {
                    return  this.options.relationshipText[d.type] || d.type;
                });
    }

    appendOutlineToRelationship = (r) => {
        return r.append('path')
                .attr('class', 'outline')
                .attr('fill', '#a5abb6')
                .attr('stroke', 'none');
    }

    appendOverlayToRelationship = (r) => {
        return r.append('path')
                .attr('class', 'overlay');
    }

    defaultColor() {
        return this.options.relationshipColor;
    }
    
    stickNode(d) {

        // d.fx = event.x;
        // d.fy = event.y;
        let coordinates =  mouse(this.svg.node());
        d.fx = coordinates[0];
        d.fy = coordinates[1];

    }

    clearInfo() {
        this.info.html('');
    }
    
    updateInfo(d) {
        this.clearInfo();
    
        if (d.labels) {
            this.appendInfoElementClass('class', d.labels[0]);
        } else {
            this.appendInfoElementRelationship('class', d.type);
        }
    
        this.appendInfoElementProperty('property', '&lt;id&gt;', d.id);
    
        Object.keys(d.properties).forEach((property) => {
            this.appendInfoElementProperty('property', property, JSON.stringify(d.properties[property]));
        });
    }

    appendInfoElementClass(cls, node) {
        this.appendInfoElement(cls, true, node);
    }

    appendInfoElement(cls, isNode, property, value) {
        var elem = this.info.append('a');

        elem.attr('href', '#')
            .attr('class', cls)
            .html('<strong>' + property + '</strong>' + (value ? (': ' + value) : ''));

        if (!value) {
            elem.style('background-color', (d) => {
                    return this.options.nodeOutlineFillColor ? this.options.nodeOutlineFillColor : (isNode ? this.class2color(property) : this.defaultColor());
                })
                .style('border-color', (d) => {
                    return this.options.nodeOutlineFillColor ? this.class2darkenColor(this.options.nodeOutlineFillColor) : (isNode ? this.class2darkenColor(property) : this.defaultDarkenColor());
                })
                .style('color', (d) => {
                    return this.options.nodeOutlineFillColor ? this.class2darkenColor(this.options.nodeOutlineFillColor) : '#fff';
                });
        }
    }

    class2color(cls) {
        let color = this.options.classes2colors[cls];

        if (!color) {
//            color = options.colors[Math.min(numClasses, options.colors.length - 1)];
            color = this.options.colors[this.numClasses % this.options.colors.length];
            this.options.classes2colors[cls] = color;
            this.numClasses++;
        }
        
        return color;
    }

    class2darkenColor(cls) {
        return rgb(this.class2color(cls)).darker(1);
    }

    defaultDarkenColor() {
        return rgb(this.options.colors[this.options.colors.length - 1]).darker(1);
    }

    dragEnded = (d) => {
        if (!event.active) {
            this.simulation.alphaTarget(0);
        }

        if (typeof this.options.onNodeDragEnd === 'function') {
            this.options.onNodeDragEnd(d);
        }
    }

    dragged = (d) => {
        this.stickNode(d);
    }

    dragStarted = (d) => {
        if (!event.active) {
            this.simulation.alphaTarget(0.3).restart();
        }

        d.fx = d.x;
        d.fy = d.y;

        if (typeof this.options.onNodeDragStart === 'function') {
            this.options.onNodeDragStart(d);
        }
    }

    appendInfoElementProperty(cls, property, value) {
        this.appendInfoElement(cls, false, property, value);
    }

    appendInfoElementRelationship(cls, relationship) {
        this.appendInfoElement(cls, false, relationship);
    }

    render() {
        return (
            <div id={this.props._selector} ref={this.neo4jD3Ref}></div>
        )
    }


}

export default Neo4jD3;